export default __webpack_public_path__ + "static/media/search.0e53c157.jpg";